// extracted by mini-css-extract-plugin
export default {"badge":"TableDeals_badge__ikeUl","tabs":"TableDeals_tabs__78AXZ"};